import { FooterAction, FooterCallToAction, FooterPromo, } from './components';
export const Footer = {
    Promo: FooterPromo,
    Action: FooterAction,
    CallToAction: FooterCallToAction,
};
